<template>
  <vs-popup class="customer-private-formulation-pop-up"
            id="popup"
            title="ADD BESPOKE FORMULATION TO CUSTOMER"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickAddPrivateFormulation)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="formulation_code" name="formulation_code" rules="" v-slot="{ errors }">
                <small class="label">Bespoke formulation</small>
                <v-select :clearable="false" name="formulation_code" label="formulation_code"  v-model="createForm.formulation_id" :reduce="option => option.id" :options="formulations" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.formulation_code}} - {{option.formulation_name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      createForm: {
        address: {}
      },
      countryCodes: [],
      formulations: []
    }
  }

export default {
  name: 'AddPrivateFormulationToCustomerPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.$vs.loading();
        this.id = id
        await this.fetchPrivateFormulationList()
        this.$vs.loading.close();
        this.open = true;
      } catch (error) {

      }
    },

    async onClickAddPrivateFormulation () {
      const vue = this;
      this.$vs.loading()
       try {
         this.createForm.customer_id = this.id
         await CustomerRepository.addPrivateFormulationToCustomer(this.createForm)
         this.showSuccessMessage('Add bespoke formulation to customer successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async fetchPrivateFormulationList() {
      this.$vs.loading()
      const {data} = await CustomerRepository.getPrivateFormulationList(this.id, this.filterQuery)
      this.formulations =  data.data
      this.$vs.loading.close()
    },
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .customer-private-formulation-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 20% !important;
  }

</style>
